var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('trev-product-selection',{attrs:{"companyId":_vm.companyId,"selectMultiple":"","defaultSelectedProducts":_vm.selectedProductsFromList,"showExistingProducts":true},on:{"selected-product":_vm.selectedProducts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }